    import React            from "react";
    import TextField        from "@mui/material/TextField";

    function CustomNumberModifica({
    name,
    label,
    onChange,
    values,
    initialValues,
    maxLength,
    }) {

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
        onChange({ [name]: value });
        }
    };

    const valueToShow =
        values[name] !== undefined ? values[name] : initialValues[name];

    return (
        <TextField
        name={name}
        label={label}
        type="text"
        variant="outlined"
        fullWidth
        inputProps={{
            maxLength: maxLength,
        }}
        value={valueToShow || ""}
        onChange={handleChange}
        sx={{
            width: "100%",
            textAlign: "left",
            borderRadius: "10px",
            backgroundColor: "#FFFFFF", 
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: "#fda03d",
                },
                "&:hover fieldset": {
                borderColor: "#fda03d", 
                },
                "&.Mui-focused fieldset": {
                borderColor: "#fda03d", 
                },
            },
            "& .MuiOutlinedInput-root.Mui-disabled": {
                bgcolor: "transparent",
                cursor: "not-allowed",
            },
            "& .Mui-disabled": {
                cursor: "not-allowed",
            },
            "& .MuiInputLabel-root.Mui-focused": {
                color: "#fda03d", 
            },
            }}
        />
    );
    }

    export default CustomNumberModifica;
